import { Nullable } from 'common/models/optional';
import { AppSyncToken } from 'common/models/token';
import { AppSyncUserInfo } from 'common/models/userInfo';
import { ChainId } from 'constants/constants';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import React from 'react';
import { CryptoUtils } from 'utils/cryptoUtils';
import { TokenUtils } from 'utils/tokenUtils';
import FormatFloat from '../FormatPercent/FormatFloat';
import { TokenIcon, TokenName } from '../TokenIcons/TokenIcon';

type Props = {
  token: AppSyncToken;
  xichi: AppSyncToken;
  name: string;
  icon: TokenName;
  type: 'legacy' | 'v2' | 'xIchiLegacy';
  userInfo: AppSyncUserInfo;
  chainId: ChainId;
};

const IchiValueRow: React.FC<Props> = (props) => {
  const getAmount = () => {
    switch (props.type) {
      case 'legacy':
        return TokenUtils.getTokenByName(props.userInfo, 'ichi').balance;
      case 'v2':
        return TokenUtils.getTokenByName(props.userInfo, 'ichi_v2').balance;
      case 'xIchiLegacy':
        return TokenUtils.getTokenByName(props.userInfo, 'xichi').balance;
      default:
        throw new Error(`${props.type} not yet implemented!`);
    }
  };

  const getValue = () => {
    switch (props.type) {
      case 'legacy':
      case 'v2':
        return (
          TokenUtils.getIchiStats(props.token, props.xichi).ichiPrice *
          getAmount()
        );
      case 'xIchiLegacy':
        return (
          TokenUtils.getIchiStats(props.token, props.xichi).xichiPrice *
          getAmount()
        );
      default:
        throw new Error(`${props.type} not yet implemented!`);
    }
  };

  const getLink = () => {
    let link: Nullable<string>;
    switch (props.type) {
      case 'legacy':
      case 'v2':
        link =
          CryptoUtils.getScannerInfo(
            props.chainId,
            props.token.address,
            'token'
          )?.link || null;
        break;
      case 'xIchiLegacy':
        link =
          CryptoUtils.getScannerInfo(
            props.chainId,
            props.xichi.address,
            'token'
          )?.link || null;
        break;
    }
    return link ? link : '';
  };

  return (
    <div className="flex flex-row justify-between py-2 sm:py-3">
      <div className="flex flex-row items-center">
        <div className="flex flex-row items-center">
          {/* <Image src={props.icon} alt="ICHI icon" /> */}
          <TokenIcon name={props.icon} height="47px" width="47px" />
          <div className="ichi-balance-header-text-color font-medium text-lg ml-2">
            {props.name}
          </div>
          <OutboundLink href={getLink()} target="_blank">
            <img
              className="icon-new-window mt-[2px] ml-2"
              alt="new window icon"
            />
          </OutboundLink>
        </div>
      </div>
      <div className="flex flex-col items-end">
        <FormatFloat
          // eslint-disable-next-line @typescript-eslint/dot-notation
          value={getValue()}
          prefix="$"
          trunc={false}
          className="ichi-balance-header-text-color font-medium text-lg"
        />
        <FormatFloat
          value={getAmount()}
          trunc={false}
          postfix={` ${props.name}`}
          className="sub-text-color font-medium text-sm"
        />
      </div>
    </div>
  );
};

export default IchiValueRow;
